import { render, staticRenderFns } from "./agent-artifact-panel.vue?vue&type=template&id=39aa3522&scoped=true"
import script from "./agent-artifact-panel.vue?vue&type=script&lang=js"
export * from "./agent-artifact-panel.vue?vue&type=script&lang=js"
import style0 from "./agent-artifact-panel.vue?vue&type=style&index=0&id=39aa3522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa3522",
  null
  
)

export default component.exports